import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import { type AccountReference, equals } from './model';

type OpenedAccountState = {
  openedAccount: string;
  accountReference: AccountReference[];
};
const initialState: OpenedAccountState = {
  openedAccount: '',
  accountReference: [],
};

export const openedAccountPagesSlice = createSlice({
  name: 'openedAccounts',
  initialState,
  reducers: {
    setOpenedAccount: (state, { payload: refAccount }: PayloadAction<string>) => {
      state.openedAccount = refAccount;
    },
    pushOpenedAccountPage: (
      state,
      { payload: accountReference }: PayloadAction<AccountReference>,
    ) => {
      if (!state.accountReference.find(equals(accountReference))) {
        state.accountReference.push(accountReference);
      }
    },
    removeOpenedAccountPage: (
      state,
      { payload: accountReference }: PayloadAction<AccountReference>,
    ) => {
      const pos = state.accountReference.findIndex(equals(accountReference));
      if (pos >= 0) {
        state.accountReference.splice(pos, 1);
      }
    },
  },
  selectors: {
    openedAccount: (state) => state.openedAccount,
    openedAccountPages: (state) => state.accountReference,
  },
});

export const {
  actions: { pushOpenedAccountPage, removeOpenedAccountPage, setOpenedAccount },
  selectors: { openedAccountPages, openedAccount },
} = openedAccountPagesSlice;
